/**
 * Whole-percent discount of a plan's live price (`amountPaise`, from GET /billing/plans)
 * off its undiscounted "regular" price (`listAmountPaise`, also from the backend).
 * Returns 0 when there's no discount — i.e. the list price isn't above the live price —
 * so callers can treat `> 0` as "show the strike-through and the % off badge".
 */
export function discountPercent(amountPaise: number, listAmountPaise: number): number {
  return listAmountPaise > amountPaise ? Math.round((1 - amountPaise / listAmountPaise) * 100) : 0
}
